import moment from 'moment';

import Base from './Base';

export default class ShortUrl extends Base {
    constructor(props, children = []) {
        super();

        this.import(props, children);
    }

    import(props) {
        if(!props) {
            props = {}
        }

        this.id = this.assign('id', props);
        this.originalUrl = this.assign('originalUrl', props);
        this.shortCode = this.assign('shortCode', props);
        this.clicks = this.assign('clicks', props) || 0;
        this.createdAt = props.createdAt ? moment(props.createdAt) : this.createdAt;
        this.updatedAt = props.updatedAt ? moment(props.updatedAt) : this.updatedAt;
    }

    export() {
        return {
            originalUrl: this.originalUrl,
            shortCode: this.shortCode
        }
    }
}
